import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../shared/constants';
import { Observable } from 'rxjs';
import { FinalProcessedSalonCountsAndTotalAmountsReport } from '../shared/models/processed-salon-count.mode';

@Injectable({ providedIn: 'root' })
export class ProcessedSalonCountService {
	private token = localStorage.getItem('token');
	private headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.token });

	private url = Constants.devServerEndpoint + 'api/processedsaloncounts';
	constructor(private httpClient: HttpClient) {}

	public getFinalProcessedSalonCounts(): Observable<FinalProcessedSalonCountsAndTotalAmountsReport[]> {
		return this.httpClient.get<FinalProcessedSalonCountsAndTotalAmountsReport[]>(this.url + `/getFinalProcessedSalonCounts/`, { headers: this.headers });
	}
}
